import { type CartItem } from '../types'

export const createDedupeProductIdsHandlers = () => {
  /**
   * 去重後的 productIds，防止因為 key 改變而重複呼叫 useApiECommerceProducts
   * Note: 操作 dedupeProductIdsSet 時不要寫在 hook 內，以維持程式碼的單純性
   */
  let dedupeProductIdsSet: Set<CartItem['cartItemId']> = new Set<CartItem['cartItemId']>()

  const mergeAndSortProductIds = (productIds: CartItem['cartItemId'][], mergedProductIds: CartItem['cartItemId'][]) => {
    return [...productIds, ...mergedProductIds].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }))
  }

  const parseCartItemProductIdsSet = (cartItems: CartItem[], extraProductIds?: CartItem['cartItemId'][]) => {
    const productIdsSet = new Set<CartItem['cartItemId']>(extraProductIds)
    const subshipProductIdsSet = new Set<CartItem['cartItemId']>()
    for (const item of cartItems) {
      if (item.subship_info) {
        subshipProductIdsSet.add(item.cartItemId)
      }
      else {
        productIdsSet.add(item.cartItemId)
      }
    }
    return {
      productIdsSet,
      subshipProductIdsSet,
    }
  }

  /**
   * 更新 dedupeProductIdsSet 並回傳去重後的 productIdsSet 和 subshipProductIdsSet
   */
  const updateAndGetDedupeCartItemProductIdsSet = (cartItems: CartItem[], extraProductIds?: CartItem['cartItemId'][]) => {
    const { productIdsSet, subshipProductIdsSet } = parseCartItemProductIdsSet(cartItems, extraProductIds)
    const nextProductIds = mergeAndSortProductIds([...productIdsSet], [...dedupeProductIdsSet])
    dedupeProductIdsSet = new Set(nextProductIds)
    return {
      productIdsSet: new Set(nextProductIds),
      subshipProductIdsSet,
    }
  }

  /**
   * 移除 dedupeProductIdsSet 中的 productIds
   */
  const removeDedupeProductIds = (productIds: CartItem['cartItemId'][]) => {
    productIds.forEach((productId) => {
      dedupeProductIdsSet.delete(productId)
    })
  }

  return {
    removeDedupeProductIds,
    updateAndGetDedupeCartItemProductIdsSet,
    parseCartItemProductIdsSet,
  }
}
